var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-col',{staticClass:"dash-filter",attrs:{"cols":"12","xs":"12","sm":"4","md":"3","lg":"3","xl":"2"}},[_c('v-autocomplete',{attrs:{"label":"Período","items":_vm.periods,"dense":"","outlined":"","hide-details":""},model:{value:(_vm.period),callback:function ($$v) {_vm.period=$$v},expression:"period"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }